/** @format */

import React, { useState, useEffect, createContext } from 'react'
import { _$, Card, Message } from '@king-design/react'
import styled from 'styled-components'
import dayjs from 'dayjs'
import { request } from 'src/utils'
import { useLocation } from 'react-router'
import API from 'src/api/ApiEventCenter'
import useGlobalData from 'src/hooks/useGlobalData'
import { RegionStateType } from 'src/store/globalDataSlice'
import MonitorCrumb from 'src/components/MonitorCrumb'
import QuickRangeDate from 'src/components/QuickRangeDate'
import EventFilter from 'src/containers/EventCenter/EventFilter'
import ChartContent from 'src/containers/EventCenter/ChartCtontent'
import TableContent from 'src/containers/EventCenter/TableContent'
import { eventListToOptions, IFilterValues, EventOptions, IContextType } from './constants'

export const CountContext = createContext<IContextType>({})

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const EventCenter: React.FC<{ className?: string }> = ({ className }) => {
  const params = useQuery()
  const product = params.get('product')
  const startTime = params.get('startTime')
  const endTime = params.get('endTime')
  // region list
  const gloabalRegionList = useGlobalData('monitorRegionList') as RegionStateType['list']
  const [date, setDate] = useState(
    startTime && endTime
      ? {
          start: dayjs(startTime).valueOf(),
          end: dayjs(endTime).valueOf()
        }
      : {
          start: dayjs().subtract(1, 'h').valueOf(),
          end: dayjs().valueOf()
        }
  )
  const [filterValues, setFilterValue] = useState<IFilterValues>({
    NamespaceId: product ? parseInt(product) : undefined,
    EventType: '',
    Name: ''
  })
  const [eventList, setEventList] = useState<any[]>([])
  const [eventOptions, setEventOptions] = useState<EventOptions[]>([])
  const [query, setQuery] = useState<string>('')
  const [chartData, setChartData] = useState<{ time: number; count: number }[]>([])
  const [tableData, setTableData] = useState<any[]>([])
  // 获取所有事件
  const getEventList = async () => {
    const result = await request(API.getListSysEvents, {
      data: {
        ProductType: 999
      }
    })
    if (result && result?.code === 'Success' && result?.data.eventList) {
      setEventList(result?.data.eventList)
      setEventOptions(eventListToOptions(result?.data.eventList) as EventOptions[])
      return result
    } else {
      Message.error(result?.message)
      return null
    }
  }

  useEffect(() => {
    getEventList()
  }, [])

  useEffect(() => {
    const { start, end } = date || {}
    if (start && end) {
      const params = {
        StartTime: start,
        EndTime: end,
        ...filterValues,
        SearchKeywords: query
      }
      getDescribeSystemEvent(params)
    }
  }, [date, filterValues, query])

  // 获取图标、列表数据
  const getDescribeSystemEvent = async params => {
    const result = await Promise.all([
      request(API.getDescribeSystemEventHistogram, { data: params }),
      request(API.getDescribeSystemEventCount, { data: params })
    ])
    if (result[0].code === 'Success' && result[1].code === 'Success') {
      const systemEventHistogram = result[0]?.data.systemEventHistogramList.SystemEventHistogram
      const systemEventCount = result[1]?.data.systemEventCounts.systemEventCount
      setChartData(systemEventHistogram || [])
      setTableData(systemEventCount || [])
    }
  }

  return (
    <div className={className}>
      <CountContext.Provider
        value={{
          date,
          eventList,
          eventOptions,
          filterValues,
          setFilterValue,
          query,
          setQuery,
          regionList: gloabalRegionList
        }}
      >
        <MonitorCrumb breadArr={[{ title: _$('事件中心') }]} />
        <Card>
          <div className="header">
            <QuickRangeDate
              format="YYYY-MM-DD HH:mm"
              optionalDateRange={90} // 默认90
              dateDiff={7}
              defautlValue={
                startTime && endTime
                  ? [dayjs(startTime).valueOf(), dayjs(endTime).valueOf()]
                  : // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
                    '近1小时'
              }
              // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
              quickRange={['近1小时', '近1天', '近3天', '近1周']}
              showShortcuts={false}
              changeValue={date => {
                setDate({
                  start: dayjs(date[0]).set('second', 0).valueOf(),
                  end: dayjs(date[1]).set('second', 0).valueOf()
                })
              }}
            />
            <EventFilter />
          </div>
          <div className="chart-content">
            <ChartContent chartData={chartData} />
          </div>
          <div className="table-content">
            <TableContent tableData={tableData} />
          </div>
        </Card>
      </CountContext.Provider>
    </div>
  )
}
export default styled(EventCenter)``
